__webpack_require__.p = "https://oip_uno.imedil.ge/";